import React from "react";

// Custom Components
import Layout from "../components/layout/Layout";
import { Helmet } from "react-helmet";
import { Container, Button } from "react-bootstrap";
import { Link } from "react-router";

import VideoGrid from "../components/youtube/VideoGrid";
import NewsletterForm from "../components/newsletter/NewsletterForm";

// Helper to build YouTube thumbnail from an ID
const ytThumb = (id) => `https://img.youtube.com/vi/${id}/hqdefault.jpg`;

// ✅ Replace these IDs + titles with your real videos.
// You can add as many categories/videos as you want without changing layout code.
const VIDEO_LIBRARY = {
  startHere: [
    {
      title: "Welcome to Stocks With Nik",
      blurb:
        "New here? This quick intro explains the vibe: learning the stock market out loud, beginner-first, no fluff.",
      href:
        "https://www.youtube.com/watch?v=MoyD9vnQU2g&utm_source=website&utm_medium=learn_page&utm_campaign=start_here",
      thumbnail: ytThumb("MoyD9vnQU2g"),
    },
    {
      title: "If I Started Investing Today… I'd Buy THIS Portfolio!",
      blurb:
        "A beginner-friendly portfolio breakdown with simple roles for each position.",
      href:
        "https://www.youtube.com/watch?v=AodVyU2HxZE&utm_source=website&utm_medium=learn_page&utm_campaign=start_here",
      thumbnail: ytThumb("AodVyU2HxZE"),
    },
    {
      title: "If You Have Kids, You Should Be Investing Like This!",
      blurb:
        "A simple long-term approach for parents—plus how to think about ETFs and staying consistent.",
      href:
        "https://www.youtube.com/watch?v=BDgpAC_yoU4&utm_source=website&utm_medium=learn_page&utm_campaign=start_here",
      thumbnail: ytThumb("BDgpAC_yoU4"),
    },
  ],

  categories: [
    {
      key: "beginner",
      title: "Beginner Investing",
      description:
        "The basics explained in plain English—what stocks are, how the market works, and how to make your first moves.",
      videos: [
        {
          title: "What Is A Stock | Beginner Friendly Explanation",
          blurb: "A simple explanation of what a stock actually is and what you own when you buy one.",
          href:
            "https://www.youtube.com/watch?v=FT54b4vqV-0&utm_source=website&utm_medium=learn_page&utm_campaign=beginner",
          thumbnail: ytThumb("FT54b4vqV-0"),
        },
        {
          title: "What is the S&P 500? (Explained in Under 5 Minutes)",
          blurb: "What the S&P 500 is, why it matters, and why beginners hear about it constantly.",
          href:
            "https://www.youtube.com/watch?v=bNeNf4YIXBw&utm_source=website&utm_medium=learn_page&utm_campaign=beginner",
          thumbnail: ytThumb("bNeNf4YIXBw"),
        },
        {
          title: "How to Buy a Stock | Step-by-Step Beginner Guide",
          blurb: "A practical walkthrough of placing a trade the beginner-friendly way.",
          href:
            "https://www.youtube.com/watch?v=OPwCNfmaq98&utm_source=website&utm_medium=learn_page&utm_campaign=beginner",
          thumbnail: ytThumb("OPwCNfmaq98"),
        },
        {
          title: "How I Research a Stock Before I Buy It",
          blurb: "A simple beginner process for research so you’re not just guessing.",
          href:
            "https://www.youtube.com/watch?v=H9xAbTlII3w&utm_source=website&utm_medium=learn_page&utm_campaign=beginner",
          thumbnail: ytThumb("H9xAbTlII3w"),
        },
      ],
    },

    {
      key: "dividends",
      title: "Dividend Investing",
      description:
        "Dividends, compounding, and how to think long-term (without chasing yield).",
      videos: [
        {
          title: "How Dividends Work | Quick Beginner Friendly Guide",
          blurb: "A clean breakdown of how dividends pay you and what to actually watch for.",
          href:
            "https://www.youtube.com/watch?v=De1mwSF9ttc&utm_source=website&utm_medium=learn_page&utm_campaign=dividends",
          thumbnail: ytThumb("De1mwSF9ttc"),
        },
        {
          title: "The SECRET to Passive Income!? - Dividend Growth Strategy Explained",
          blurb: "How dividend growth can build long-term income without relying on hype.",
          href:
            "https://www.youtube.com/watch?v=2vKj0dhjC5o&utm_source=website&utm_medium=learn_page&utm_campaign=dividends",
          thumbnail: ytThumb("2vKj0dhjC5o"),
        },
        {
          title: "Growth Stocks vs Dividend Stocks",
          blurb: "A quick comparison so you understand the tradeoffs (and how to balance both).",
          href:
            "https://www.youtube.com/watch?v=y2u_i5hpDKs&utm_source=website&utm_medium=learn_page&utm_campaign=dividends",
          thumbnail: ytThumb("y2u_i5hpDKs"),
        },
      ],
    },

    {
      key: "portfolio",
      title: "Portfolio Building",
      description:
        "How to structure a portfolio, assign roles, and keep things simple enough to stick with.",
      videos: [
        {
          title: "Core and Satellite Investing Strategy (Beginner Friendly Guide)",
          blurb: "A smart way to build a strong core portfolio and add smaller ‘satellite’ positions.",
          href:
            "https://www.youtube.com/watch?v=EXCG2KQTEVU&utm_source=website&utm_medium=learn_page&utm_campaign=portfolio",
          thumbnail: ytThumb("EXCG2KQTEVU"),
        },
        {
          title: "These 3 ETFs Could DOMINATE 2026!",
          blurb: "A forward-looking ETF discussion and how to think about themes + long-term holds.",
          href:
            "https://www.youtube.com/watch?v=hVIsZv17VJA&utm_source=website&utm_medium=learn_page&utm_campaign=portfolio",
          thumbnail: ytThumb("hVIsZv17VJA"),
        },
        {
          title: "If I Started Investing Today… I'd Buy THIS Portfolio!",
          blurb: "A clean beginner portfolio structure with a simple explanation for each holding.",
          href:
            "https://www.youtube.com/watch?v=AodVyU2HxZE&utm_source=website&utm_medium=learn_page&utm_campaign=portfolio",
          thumbnail: ytThumb("AodVyU2HxZE"),
        },
      ],
    },

    {
      key: "themes",
      title: "Trends & Themes (Optional)",
      description:
        "If you want a section for high-interest topics like AI—still long-term focused, not trading.",
      videos: [
        {
          title: "AI Is TAKING OFF — Here Are 2 Stocks You SHOULDN'T Ignore!!",
          blurb: "A beginner-friendly look at AI momentum and two names worth learning about.",
          href:
            "https://www.youtube.com/watch?v=fnpvWBH0TCR8&utm_source=website&utm_medium=learn_page&utm_campaign=themes",
          thumbnail: ytThumb("npvWBH0TCR8"),
        },
      ],
    },
  ],
};


function SectionHeader({ title, description }) {
  return (
    <div className="mb-3" style={{ textAlign: "center" }}>
      <h2 className="mb-2">{title}</h2>
      {description ? (
        <p className="text-muted" style={{ maxWidth: 900, margin: "0 auto" }}>
          {description}
        </p>
      ) : null}
    </div>
  );
}

export default function Learn() {
  return (
    <>
      <Helmet>
        <title>Learn Investing | Stocks With Nik</title>
        <meta
          name="description"
          content="Learn beginner-friendly investing with Stocks With Nik. Watch curated videos on ETFs, dividends, and building simple long-term portfolios."
        />
      </Helmet>

      <Layout
        content={
          <Container className="mt-5 mb-5">
            {/* Page Intro */}
            <div className="p-2 mb-4" style={{ textAlign: "center" }}>
              <h1 className="mb-2">Learn Investing The Simple Way</h1>
              <p
                className="text-muted"
                style={{ maxWidth: 900, margin: "0 auto" }}
              >
                I’m not a financial advisor — I’m just documenting what I’m
                learning about long-term investing and sharing it in a way that
                beginners can actually understand. If you’re new here, start
                with the “Start Here” picks below.
              </p>
            </div>

            {/* Start Here */}
            <div className="mt-4">
              <SectionHeader
                title="New to Investing? Start Here."
                description="These are the first videos I’d recommend if you’re brand new to stocks, ETFs, and building your first portfolio."
              />
              <VideoGrid videos={VIDEO_LIBRARY.startHere} />
            </div>

            {/* Categories */}
            {VIDEO_LIBRARY.categories.map((cat) => (
              <div key={cat.key} className="mt-5">
                <SectionHeader title={cat.title} description={cat.description} />
                <VideoGrid videos={cat.videos} />
              </div>
            ))}

            {/* CTA */}
            <div className="mt-5 p-3" style={{ textAlign: "center" }}>
                <h3>Not sure what fits you best? </h3>
              <p className="mb-2">
                Take the free AI Portfolio Quiz and
                get a beginner-friendly portfolio built around your goals.
              </p>
              <Link to="/quiz">
                <Button>Build My Portfolio</Button>
              </Link>
              <NewsletterForm />
            </div>
          </Container>
        }
      />
    </>
  );
}
